import React from 'react'

import Badge from '@instabox/internal-web-ui/components/Badge'
import Button from '@instabox/internal-web-ui/components/Button'
import Modal from '@instabox/internal-web-ui/components/Modal'
import Table from '@instabox/internal-web-ui/components/Table'
import ValidationMessage from '@instabox/internal-web-ui/components/ValidationMessage'
import { BaselineCandidatePackage, BaselinePackage } from '@instabox/lockers-update-common/types'

import './ConfirmationModal.scss'

interface ConfirmationModal {
  show: boolean
  onCancel: () => void
  onConfirm: () => Promise<void>
  totalChanges: number
  processedBaseline: BaselineCandidatePackage[]
  newBaselinePkgs: BaselinePackage[]
}

const ConfirmationModal: React.FC<ConfirmationModal> = ({
  show = false,
  onCancel,
  onConfirm,
  totalChanges,
  processedBaseline,
  newBaselinePkgs,
}) => (
  <Modal isOpen={show} title="Confirm changes" withCloseButton withInnerSpace onClose={() => onCancel()}>
    <p>Please review the changes to be applied before saving the new baseline.</p>
    <div className="tablesContainer">
      <div className="tableColumn newBaseline">
        <p>
          <b>New baseline being established:</b>
        </p>
        <Table
          style={{ overflow: 'hidden' }}
          headers={{
            name: 'Package',
            version: 'Version',
          }}
          rows={newBaselinePkgs.map((pkg) => ({
            name: pkg.name,
            version: (
              <Badge variant="pink" size="sm">
                <b>{pkg.selectedVersion}</b>
              </Badge>
            ),
          }))}
        />
      </div>
      <div className="tableColumn changes">
        <p>
          <b>Changes from current baseline:</b>
        </p>
        <Table
          style={{ overflow: 'hidden' }}
          headers={{
            name: 'Package',
            message: 'Change',
          }}
          rows={processedBaseline.map((pkg) => ({
            name: pkg.name,
            message: <ValidationMessage type={pkg.type} message={pkg.message} />,
          }))}
        />
      </div>
    </div>

    <p>
      Are you sure you set these as the new baseline? <b>ALL</b> lockers will be affected by this change!
    </p>

    <Button data-testid="rolloutSubmitButton" size="lg" type="button" onClick={onConfirm} disabled={!totalChanges}>
      Confirm changes
    </Button>
  </Modal>
)

export default ConfirmationModal
